import { useState } from "react";
import Style from "./styles";
import { useEffect } from "react";

const Maintenance = ({ setIsMaintenance }) => {
  const [logoClick, setLogoClick] = useState(1);

  useEffect(() => {
    if (logoClick > 10) {
      const password = window.prompt("ENTER PIN CODE", "");
      if (password === process.env.REACT_APP_MAINTENANCE_PASSWORD) {
        setIsMaintenance(false);
        setLogoClick(0);
      } else {
        window.alert("WRONG PIN CODE");
        setLogoClick(0);
      }
    }
  }, [logoClick]);

  return (
    <Style.WrapperDiv>
      <Style.ContentDiv>
        <Style.MaintenanceImage
          onClick={() => setLogoClick(logoClick + 1)}
          src={require("shared/asset/maintenance.jpg")}
          alt="maintenance"
        />
      </Style.ContentDiv>
    </Style.WrapperDiv>
  );
};

export default Maintenance;
